"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icons_1 = require("@ant-design/icons");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var __1 = require("../../../..");
var Popup_1 = __importDefault(require("../../../Popup/Popup"));
var Utils_1 = require("./Utils");
var PopupChildren = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: auto;\n  max-height: 90vh;\n  margin: 1em;\n"], ["\n  overflow: auto;\n  max-height: 90vh;\n  margin: 1em;\n"])));
var DokumentyDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: grid;\n  row-gap: 10px;\n"], ["\n  display: grid;\n  row-gap: 10px;\n"])));
var InfoDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: #f7f9fa;\n  padding: 11px 14px;\n"], ["\n  background-color: #f7f9fa;\n  padding: 11px 14px;\n"])));
var FlexBox = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  ", "\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  ",
    "\n"])), function (_a) {
    var justify = _a.justify;
    return justify && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      justify-content: ", ";\n    "], ["\n      justify-content: ", ";\n    "])), justify);
});
var StavDiv = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: white;\n  padding: 4px 14px;\n  margin-bottom: 10px;\n  ", "\n"], ["\n  color: white;\n  padding: 4px 14px;\n  margin-bottom: 10px;\n  ",
    "\n"])), function (_a) {
    var color = _a.color;
    return color && styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), color);
});
var MarginDIv = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin-bottom: 1em;\n"], ["\n  margin-bottom: 1em;\n"])));
var StyledButton = styled_components_1.default(__1.Button)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  background-color: ", ";\n  color: #ffffff;\n  border-color: ", ";\n  &:active {\n    background-color: ", ";\n  }\n  cursor: ", ";\n"], ["\n  background-color: ", ";\n  color: #ffffff;\n  border-color: ", ";\n  &:active {\n    background-color: ", ";\n  }\n  cursor: ", ";\n"])), function (props) { return (props.$isDisabled ? '#dddddd' : '#1ca854'); }, function (props) { return (props.$isDisabled ? '#dddddd' : '#1ca854'); }, function (props) { return !props.$isDisabled && '#147a3d'; }, function (props) { return props.$isDisabled && 'unset'; });
var ErrorDiv = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  padding-bottom: 5px;\n"], ["\n  padding-bottom: 5px;\n"])));
var opravnaVerze = function (dokumenty) {
    return dokumenty.filter(function (d) { return d.stav.id === __1.StavPojisteni.Schvaleno || d.stav.id === __1.StavPojisteni.CekaNaSchvaleni; }).length;
};
var PojisteniPopup = function (_a) {
    var open = _a.open, setIsOpen = _a.setIsOpen, item = _a.item, handleOpravu = _a.handleOpravu, idZnalce = _a.idZnalce, isNahratDisabled = _a.isNahratDisabled;
    var token = __1.useToken();
    var roleIds = (token.getDataFromToken() || []).roleIds;
    var pojisteniUrl = __1.useConfig().pojisteniUrl;
    var getDokument = __1.useGetFile(pojisteniUrl + "/StazeniDokumentu");
    var _b = react_1.useState(), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = react_1.useState(), loading = _c[0], setLoading = _c[1];
    var handleClickOprava = function (oprava) {
        handleOpravu(oprava);
        setIsOpen(!open);
    };
    var handleStahnout = function (dokument) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(dokument.id);
                    setErrorMessage(undefined);
                    return [4 /*yield*/, getDokument({ idZnalec: idZnalce, odkaz: dokument.odkaz })];
                case 1:
                    response = _a.sent();
                    if (!__1.isRight(response)) return [3 /*break*/, 3];
                    if (response.value.status === 204) {
                        setErrorMessage('Dokumenty starší více než 2 roky jsou odstraněny.');
                        setLoading(undefined);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, __1.downloadFile(response.value, "" + dokument.nazev, true)];
                case 2:
                    error = _a.sent();
                    if (error) {
                        setErrorMessage(error);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setErrorMessage('Stahování selhalo.');
                    _a.label = 4;
                case 4:
                    setLoading(undefined);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClose = function () {
        setIsOpen(false);
        setErrorMessage(undefined);
    };
    return (react_1.default.createElement("div", null, (item === null || item === void 0 ? void 0 : item.dokumenty) && (react_1.default.createElement(Popup_1.default, { open: open, onClose: handleClose },
        react_1.default.createElement(PopupChildren, null,
            react_1.default.createElement("h2", null, "Profesn\u00ED poji\u0161t\u011Bn\u00ED"),
            errorMessage && (react_1.default.createElement(ErrorDiv, null,
                react_1.default.createElement(__1.Message, { type: "error", onClose: function () { return setErrorMessage(undefined); } }, errorMessage))),
            react_1.default.createElement(DokumentyDiv, null, item.dokumenty.map(function (d) { return (react_1.default.createElement(InfoDiv, { key: "dokument-" + d.id },
                react_1.default.createElement(FlexBox, null,
                    react_1.default.createElement(StavDiv, { color: Utils_1.getStavColor(d.stav.id) }, d.stav.nazev),
                    react_1.default.createElement("b", null,
                        "Nahr\u00E1no: ",
                        __1.formatDate(d.datumVlozeni))),
                react_1.default.createElement(__1.LinkButton, { onClick: function () { return handleStahnout(d); }, disabled: loading === d.id },
                    react_1.default.createElement("b", null,
                        d.nazev,
                        loading === d.id && react_1.default.createElement(icons_1.LoadingOutlined, { spin: true }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("b", null,
                        item.druhyDokladu.map(function (dok) { return dok.nazev; }).join(', '),
                        " ",
                        item.dokumenty.indexOf(d) !== item.dokumenty.length - 1 && '(opravná verze)')),
                react_1.default.createElement("br", null),
                d.stav.id === __1.StavPojisteni.Zamitnuto && (react_1.default.createElement(MarginDIv, null,
                    react_1.default.createElement("b", null, "D\u016Fvod zam\u00EDtnut\u00ED: "),
                    d.duvodZamitnuti)),
                react_1.default.createElement(MarginDIv, null,
                    react_1.default.createElement("b", null, "Pozn\u00E1mka: "),
                    d.poznamka),
                __1.isInRole([__1.Role.Editor], roleIds) && (react_1.default.createElement(FlexBox, { justify: "end" },
                    react_1.default.createElement(__1.Link, { to: "/zasobnik-prace?idDokument=" + d.id }, "Zobrazit \u00FAkol"))),
                __1.isInRole([__1.Role.znalec], roleIds) && !opravnaVerze(item.dokumenty) && item.dokumenty.indexOf(d) === 0 && (react_1.default.createElement(FlexBox, { justify: "center" },
                    react_1.default.createElement(__1.Tooltip, { content: "V\u00E1mi nahran\u00FD doklad o poji\u0161t\u011Bn\u00ED je v tuto chv\u00EDli posuzov\u00E1n \u2013 aktu\u00E1ln\u011B tedy nen\u00ED mo\u017En\u00E9 nahr\u00E1t dal\u0161\u00ED.", disabled: !isNahratDisabled },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(StyledButton, { name: "OpravnaVerze", onClick: function () { return handleClickOprava({ idZamitnuty: d.id, idDoklad: item.id }); }, disabled: isNahratDisabled, "$isDisabled": isNahratDisabled }, "Opravn\u00E1 verze"))))))); })))))));
};
PojisteniPopup.defaultProps = {
    open: undefined,
    item: undefined,
};
exports.default = PojisteniPopup;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
